import React, { useEffect, useRef } from "react";
import { Input, Label, UncontrolledTooltip } from "reactstrap";
import { truncateUrl } from "./writingAssistantUtils";

function formatUrlOptionLabel(page) {
	const title = page.title || "Untitled";
	return `${title} — ${truncateUrl(page.url)}`;
}

function formatUrlOptionTitle(page) {
	const title = page.title || "Untitled";
	return `${title} — ${page.url}`;
}

export default function UrlSelectSection({
	pages,
	selectedPageUrl,
	onSelect,
	recommendationId,
}) {
	const sectionRef = useRef(null);
	const selectRef = useRef(null);

	useEffect(() => {
		if (!pages?.length || recommendationId == null) return;

		sectionRef.current?.scrollIntoView({
			behavior: "smooth",
			block: "nearest",
		});

		const timer = setTimeout(() => {
			selectRef.current?.focus();
		}, 350);

		return () => clearTimeout(timer);
	}, [recommendationId, pages]);

	if (!pages || pages.length === 0) return null;

	const selectedPage = pages.find((p) => p.url === selectedPageUrl) ?? null;

	return (
		<div
			ref={sectionRef}
			id="writing-assistance-url-section"
			className="writing-assistance__field"
		>
			<Label for="writing-assistance-url" className="writing-assistance__label">
				URL
			</Label>

			<div id="writing-assistance-url-wrap" className="writing-assistance__url-select-wrap">
				<Input
					id="writing-assistance-url"
					innerRef={selectRef}
					type="select"
					className="writing-assistance__select"
					value={selectedPageUrl ?? ""}
					title={selectedPage ? formatUrlOptionTitle(selectedPage) : undefined}
					onChange={(e) => onSelect(e.target.value || null)}
				>
					<option value="">Select a page…</option>
					{pages.map((page) => (
						<option key={page.url} value={page.url} title={formatUrlOptionTitle(page)}>
							{formatUrlOptionLabel(page)}
						</option>
					))}
				</Input>

				{selectedPage && (
					<UncontrolledTooltip
						placement="top"
						target="writing-assistance-url-wrap"
						innerClassName="writing-assistance__url-tooltip"
					>
						{selectedPage.title && (
							<div className="writing-assistance__url-tooltip-title">{selectedPage.title}</div>
						)}
						<div className="writing-assistance__url-tooltip-url">{selectedPage.url}</div>
					</UncontrolledTooltip>
				)}
			</div>

			{selectedPage && (
				<p
					className="writing-assistance__url-selected mb-0 mt-2"
					title={formatUrlOptionTitle(selectedPage)}
				>
					Selected: {selectedPage.url}
				</p>
			)}
		</div>
	);
}

